const petcoSpacing = {
  micro: '.125rem',
  xSmall: '.25rem',
  small: '.5rem',
  medium: '1rem',
  large: '2rem',
  xLarge: '4rem',
};

export default petcoSpacing;
